import React from 'react'
import useActiveCompany from '@vero/ui-core-browser/hooks/active-company.js'
import useRedirectParam from '@vero/ui-core-browser/hooks/redirect-param.js'
import Page from '@vero/ui-components/pages/page.jsx'
import Redirecting from '@vero/ui-components/components/redirecting.jsx'
import AuthedPage from '../pages/authed-page.jsx'
import CompanyList from '../widgets/company-list.jsx'

export default function ({ title, children }) {
  const { activeCompany } = useActiveCompany()
  const { redirect } = useRedirectParam()

  if (activeCompany?.slug) {
    window.location.href = redirect

    return (
      <Page title={title}>
        <Redirecting />
      </Page>
    )
  }

  return (
    <AuthedPage title={title}>
      <CompanyList />
      {children}
    </AuthedPage>
  )
}
